/**
 * Stacking order for node/edge contextual toolbars (and the line grips)
 * inside the React Flow viewport. React Flow lifts a selected node to 1000
 * and an edge whose node sits in a section to that node's level plus its
 * own, so anything that must stay above both starts above 1002.
 */
export const CANVAS_FLOATING_TOOLBAR_Z_INDEX = 1100;
/** The edge-label layer: above every edge, under the toolbars. */
export const CANVAS_EDGE_LABEL_Z_INDEX = 1050;
